// extracted by mini-css-extract-plugin
export default {"Text":"ChangeWorkflowOrder_Text__ndsH1"};